import _ from "lodash";
import React, { useEffect, useState, memo } from "react";
import { withRouter } from "react-router";

import classes from "./SupportDropdown.scss";
import classNames from "classnames";

import { IntercomChat } from "SvgComponents";

import { recordEvent } from "lib/eventTracker";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";

import {
  IconButton,
  Dropdown,
  Badge,
  useKeyboardShortcutsContext,
} from "@toddle-edu/ds-web";
import {
  StarOutlined,
  HelpOutlined,
  VideosOutlined,
  BoltOutlined,
  SmileySatisfiedOutlined,
  ArrowOutOutlined,
  LayersAddOutlined,
} from "@toddle-edu/ds-icons";

import {
  isUserTypeStaff,
  isUserTypeParent,
  isUserTypeStudent,
} from "AttendanceSummary/modules/Utils";

import {
  openChat,
  getUserInfo,
  toggleIsSprinklrChatOpen,
  setSprinklrUnreadMessageCount,
  isLibraryRoute,
  isToddleLibraryRoute,
} from "Login/modules/LoginModule";

import { useI18n } from "Hooks";

import ACLStore from "lib/aclStore";

import {
  goToRelativeRoute,
  openLinkInNewTab,
  toggleGlobalSearchBarModal,
} from "modules/Services";
import {
  getSelectedCurriculumId,
  getUserCurriculumPrograms,
} from "modules/CommonSelectors";

import { getShowSprinklrChat, getProductFeedbackRoute } from "Utils";

import { SUPPORT_DROPDOWN_CONSTANTS } from "./constants/supportDropdownConstants";
import { hideIntercom } from "lib/intercom";
import { CURRICULUM_TYPE_UBD } from "Constants/stringConstants";
import { getWorkrampLoginUrl } from "Courses/modules/CoursesModule";
import { loadSprinklr, openSprinklrChat } from "lib/sprinklr";
import { isWindows } from "Utils/DeviceDetectHelpers";
import { getHelCenterUrl } from "AppComponents/ToddleAcademyThirdPane/ToddleAcademyThirdPane";
import {
  isProductUpdateV2Enabled,
  mapleBearLikeOrg,
} from "Courses/modules/utils";
import { ENABLE_INTERCOM_CONSUMPTION } from "Constants/permissionConstants";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import { getUserRnpRolesEnhancer } from "modules/CommonQueryEnhancers";
import { getIsRnpConsumptionAllowed } from "AttendanceDashboard/modules/Utils";

const GLOBAL_SEARCH_TRIGGER_KEY = "J";

const getIntercomOptions = ({
  t,
  userType,
  activeTab,
  trayMode,
  userInfo,
  sprinklrUnreadMessageCount,
  showSprinklrChat,
  isGlobalSearchRevampEnabled,
  isGlobalSearchJumpToV2Enabled,
  shouldShowGlobalSearchBar,
  areShortcutsEnabled,
  isProductRequestAllowed,
}) => {
  const { user_type } = userInfo;
  const globalSearchVisible =
    ACLStore.can([
      "TeacherPortal:GlobalSearchBar",
      "StudentPortal:GlobalSearchBar",
    ]) &&
    activeTab !== SUPPORT_DROPDOWN_CONSTANTS.COMMUNITY &&
    shouldShowGlobalSearchBar;

  const iconVariant = trayMode ? "default" : "on";

  const intercomLoggedInUserFeature = [
    {
      key: SUPPORT_DROPDOWN_CONSTANTS.TODDLE_ACADEMY,
      label: t("common:toddle_academy"),
      perm: "FeatureFlag:WorkrampAcademy",
      userTypes: ["staff"],
      isVisible: activeTab === SUPPORT_DROPDOWN_CONSTANTS.TEACHER,
      icon: <VideosOutlined variant={iconVariant} />,
      rightIcon: <ArrowOutOutlined variant={iconVariant} />,
    },
    {
      key: SUPPORT_DROPDOWN_CONSTANTS.HELP_CENTER,
      label: t("teacherHomePage:helpCenter"),
      perm: "Common:EnableHelpCenter",
      userTypes: ["staff"],
      isVisible: true,
      icon: <HelpOutlined variant={iconVariant} />,
      rightIcon: <ArrowOutOutlined variant={iconVariant} />,
    },
    {
      key: SUPPORT_DROPDOWN_CONSTANTS.WHATS_NEW,
      label: t("common:product_updates"),
      perm: "Common:ShowProductUpdates",
      userTypes: ["staff"],
      isVisible: activeTab === SUPPORT_DROPDOWN_CONSTANTS.TEACHER,
      icon: <StarOutlined variant={iconVariant} />,
    },
    {
      key: SUPPORT_DROPDOWN_CONSTANTS.ROADMAP_FEATURES_REQUEST,
      label: t("common:feature_requests"),
      perm: "FeatureFlag:EnableProductFeedbackFlow",
      userTypes: ["staff"],
      isVisible:
        activeTab === SUPPORT_DROPDOWN_CONSTANTS.TEACHER &&
        isProductRequestAllowed,
      icon: <LayersAddOutlined variant={iconVariant} />,
      rightIcon: <ArrowOutOutlined variant={iconVariant} />,
    },
  ];

  const options = _.filter(intercomLoggedInUserFeature, item => {
    if (_.includes(item.userTypes, userType)) {
      const isPermEnabled = item.perm ? ACLStore.can(item.perm) : true;
      return item.isVisible ? isPermEnabled : false;
    } else {
      return false;
    }
  });
  const isContactSupportEnabled = ACLStore.can(
    "FeatureFlag:ShowContactSupport"
  );

  if (globalSearchVisible) {
    let quickSearchRightIconElement;

    if (!areShortcutsEnabled) {
      quickSearchRightIconElement = null;
    } else if (isGlobalSearchRevampEnabled && !isGlobalSearchJumpToV2Enabled) {
      quickSearchRightIconElement = (
        <span
          className={classNames({
            dark: !trayMode,
          })}
        >
          <Badge
            dsVersion="2.0"
            shape="square"
            value={GLOBAL_SEARCH_TRIGGER_KEY}
            type="shortcut"
          />
        </span>
      );
    } else {
      quickSearchRightIconElement = (
        <div
          className={classNames(classes.shortcutContainer, "text-body-xs", {
            dark: !trayMode,
          })}
        >
          <Badge
            dsVersion="2.0"
            shape="square"
            value={isWindows() ? "Ctrl" : <>&#x2318;</>}
            type="shortcut"
          />
          +
          <Badge dsVersion="2.0" shape="square" value={"/"} type="shortcut" />
        </div>
      );
    }

    options.push({
      key: SUPPORT_DROPDOWN_CONSTANTS.DIVIDER_1,
      isDivider: true,
    });
    options.push({
      key: SUPPORT_DROPDOWN_CONSTANTS.QUICK_SEARCH,
      label: t("common:quick_search"),
      icon: <BoltOutlined variant={iconVariant} />,
      rightIcon: quickSearchRightIconElement,
    });
  }

  const showGlobalMenuTray = ACLStore.can("FeatureFlag:EnableGlobalMenuTray");

  if (_.size(options)) {
    options.push({
      isDivider: true,
    });
  }
  const isMapleBearLikeOrg = mapleBearLikeOrg();

  if (!showSprinklrChat) {
    if (
      user_type === "staff" &&
      ACLStore.can(ENABLE_INTERCOM_CONSUMPTION) &&
      !isMapleBearLikeOrg
    ) {
      options.push({
        key: SUPPORT_DROPDOWN_CONSTANTS.CONTACT_SUPPORT,
        label: t("common:contact_support"),
        icon: <SmileySatisfiedOutlined variant={iconVariant} />,
      });
    }
  }
  if (_.includes(["student", "parent"], user_type) && showSprinklrChat) {
    options.push({
      key: SUPPORT_DROPDOWN_CONSTANTS.SCHOOL_SUPPORT,
      label: t("common:school_support"),
      icon: (
        <SmileySatisfiedOutlined
          variant={showGlobalMenuTray ? "iconVariant" : "on"}
        />
      ),
      rightIcon: (
        <Badge
          variant={"notifications"}
          size={"medium"}
          value={sprinklrUnreadMessageCount}
          type={"numeric"}
          showZero={false}
        />
      ),
    });
  }
  if (_.includes(["staff"], user_type) && showSprinklrChat) {
    options.push({
      key: SUPPORT_DROPDOWN_CONSTANTS.MAPLE_BEAR_CENTRAL_SUPPORT,
      label: t("common:maple_bear_central_support"),
      icon: (
        <SmileySatisfiedOutlined
          variant={showGlobalMenuTray ? "iconVariant" : "on"}
        />
      ),
      rightIcon: (
        <Badge
          variant={"notifications"}
          size={"medium"}
          value={sprinklrUnreadMessageCount}
          type={"numeric"}
          showZero={false}
        />
      ),
    });
  }

  return options;
};

const dropdownPosition = {
  targetOffset: [140, -8],
};

const _SupportDropdown = props => {
  const {
    activeTab,
    userLoggedIn,
    showIntercom,
    isIntercomV2Enabled,
    curriculumProgramId,
    userId,
    userEntityType,
    userType,
    goToRelativeRoute,
    openLinkInNewTab,
    toggleGlobalSearchBarModal,
    trayMode = false,
    closeAllOptions,
    variant = "subtle",
    userInfo,
    showSprinklrChat,
    getWorkrampLoginUrl,
    buttonIcon,
    isSprinklrChatOpen,
    toggleIsSprinklrChatOpen,
    setSprinklrUnreadMessageCount,
    sprinklrUnreadMessageCount,
    isGlobalSearchRevampEnabled,
    isGlobalSearchJumpToV2Enabled,
    shouldShowGlobalSearchBar,
    isUBD,
    rnpRoleContextDetail,
  } = props;

  const { t } = useI18n(["common", "teacherHomePage"]);
  const [isButtonActive, setIsButtonActive] = useState(false);

  const firstAppId = _.get(_.first(userInfo?.userDetailsHash), "appId", "");

  const { areShortcutsEnabled } = useKeyboardShortcutsContext();

  useEffect(() => {
    if (userLoggedIn && isIntercomV2Enabled) hideIntercom();
  }, []);

  useEffect(() => {
    if (
      _.includes(["parent"], userInfo?.user_type) &&
      showSprinklrChat &&
      firstAppId
    ) {
      const childUserDetailsHash = _.find(
        userInfo?.userDetailsHash,
        data => data.organizationId === userInfo?.org_id
      );
      if (window.sprChat) {
        const chatApp = document.getElementById("spr-live-chat-app");

        chatApp?.remove();
        window.sprChat.loaded = false;
        toggleIsSprinklrChatOpen(false);
        setIsButtonActive(false);
      }

      const appId = _.get(childUserDetailsHash, "appId", "");
      const sprinklrChatHash = _.get(
        childUserDetailsHash,
        "sprinklrChatHash",
        ""
      );
      const userServiceId = _.get(childUserDetailsHash, "userServiceId", "");
      if (showSprinklrChat && firstAppId) {
        loadSprinklr({
          userServiceId,
          appId,
          userInfo,
          chatHash: sprinklrChatHash,
          toggleIsSprinklrChatOpen,
          setSprinklrUnreadMessageCount,
        });
      }
    } else if (showSprinklrChat && firstAppId) {
      const appId = _.get(userInfo, "userDetailsHash[0].appId", "");
      const sprinklrChatHash = _.get(
        _.first(userInfo?.userDetailsHash),
        "sprinklrChatHash",
        ""
      );
      const userServiceId = _.get(
        _.first(userInfo?.userDetailsHash),
        "userServiceId",
        ""
      );
      loadSprinklr({
        userServiceId,
        appId,
        userInfo,
        chatHash: sprinklrChatHash,
        toggleIsSprinklrChatOpen,
        setSprinklrUnreadMessageCount,
      });
    }
  }, [userInfo?.org_id, firstAppId]);

  const userGlobalRolesUids = _.map(rnpRoleContextDetail, rc =>
    _.get(rc, "role.globalRole.uid")
  );
  const isAdmin = getIsAdminByRole();

  const isProductRequestAllowed = getIsRnpConsumptionAllowed()
    ? _.size(
        _.intersection(userGlobalRolesUids, [
          "SUPER_ADMIN",
          "IT_ADMIN",
          "PROGRAMME_ADMIN",
        ])
      ) > 0
    : isAdmin;

  const handleVisitorContactUs = (value, userInfo) => {
    openChat(value, userInfo);
  };

  const handleIntercomOptionClick = async value => {
    switch (value) {
      case SUPPORT_DROPDOWN_CONSTANTS.HELP_CENTER: {
        const helpCenterRoute = getHelCenterUrl(isUBD);

        openLinkInNewTab({
          url: helpCenterRoute,
        });
        break;
      }

      case SUPPORT_DROPDOWN_CONSTANTS.WHATS_NEW:
        if (curriculumProgramId) {
          await goToRelativeRoute({
            route: isProductUpdateV2Enabled()
              ? `platform/${curriculumProgramId}/productUpdates`
              : `platform/${curriculumProgramId}/product-updates`,
            type: "replace",
            replacePath: "platform",
          });
        }
        break;

      case SUPPORT_DROPDOWN_CONSTANTS.TODDLE_ACADEMY: {
        const workrampAuthUrl = await getWorkrampLoginUrl({
          id: userId,
          type: userEntityType,
        });
        openLinkInNewTab({
          url: workrampAuthUrl,
        });
        break;
      }

      case SUPPORT_DROPDOWN_CONSTANTS.QUICK_SEARCH:
        recordEvent({
          eventName: "GLOBAL_SEARCH",
          eventData: {
            event_type: "OPEN",
            triggerPoint: "MOUSE_INTERCOM",
          },
        });

        toggleGlobalSearchBarModal();
        break;

      case SUPPORT_DROPDOWN_CONSTANTS.CONTACT_SUPPORT:
        handleVisitorContactUs();
        break;

      case SUPPORT_DROPDOWN_CONSTANTS.SCHOOL_SUPPORT:
      case SUPPORT_DROPDOWN_CONSTANTS.MAPLE_BEAR_CENTRAL_SUPPORT:
        openSprinklrChat();
        break;
      case SUPPORT_DROPDOWN_CONSTANTS.ROADMAP_FEATURES_REQUEST: {
        const productFeedbackRoute = getProductFeedbackRoute();

        openLinkInNewTab({
          url: productFeedbackRoute,
        });
        break;
      }
    }
  };

  const onClickIntercomIcon = () => {
    setIsButtonActive(prevState => !prevState);
  };

  const renderIntercomDropdown = () => {
    const intercomClass = classNames({
      [classes.showIntercom]: showIntercom,
      [classes.hideIntercom]: !showIntercom,
    });

    const renderDropdownOverlay = () => {
      const options = getIntercomOptions({
        t,
        userType,
        activeTab,
        trayMode,
        userInfo,
        sprinklrUnreadMessageCount,
        showSprinklrChat,
        isGlobalSearchRevampEnabled,
        isGlobalSearchJumpToV2Enabled,
        shouldShowGlobalSearchBar,
        areShortcutsEnabled,
        isProductRequestAllowed,
      });
      return _.map(options, ({ key, label, icon, rightIcon, isDivider }) => {
        const handleIntercomClick = event => {
          handleIntercomOptionClick(key);
          event.stopPropagation();
        };

        const optionDividerStyles = classNames({
          [classes.optionDivider]: true,
          [classes.optionDividerDark]: !trayMode,
        });

        const renderDivider = () => {
          return <div className={optionDividerStyles} key={key} />;
        };

        const optionContainerStyles = classNames({
          [classes.optionContainer]: true,
          [classes.optionContainerDark]: !trayMode,
        });

        const optionLabelStyles = classNames({
          [classes.optionLabel]: true,
          [classes.optionLabelDark]: !trayMode,
        });

        return isDivider ? (
          renderDivider()
        ) : (
          <div
            className={optionContainerStyles}
            onClick={handleIntercomClick}
            key={key}
          >
            <div className={classes.optionLeftContainer}>
              <div className={classes.iconContainer}>{icon}</div>
              <div className={optionLabelStyles}>{label}</div>
            </div>
            {rightIcon && (
              <div className={classes.optionRightContainer}>{rightIcon}</div>
            )}
          </div>
        );
      });
    };

    const renderIntercomIcon = ({ handler }) => {
      return trayMode ? (
        <div className={classes.trayIconContainer} onClick={handler}>
          {trayMode ? (
            buttonIcon
          ) : (
            <HelpOutlined variant={variant} size="x-small" />
          )}
        </div>
      ) : sprinklrUnreadMessageCount > 0 && !isButtonActive ? (
        <IconButton
          icon={
            <Badge
              variant={"notifications"}
              size={"medium"}
              value={sprinklrUnreadMessageCount}
              type={"numeric"}
              showZero={false}
            >
              <IntercomChat />
            </Badge>
          }
          variant="dark"
          size="medium"
          onClick={handler}
        />
      ) : (
        <IconButton
          icon={<IntercomChat />}
          variant="dark"
          size="medium"
          onClick={handler}
        />
      );
    };

    const overlayContainerStyles = classNames({
      [classes.overlayContainer]: true,
      [classes.overlayContainerDark]: !trayMode,
    });

    const onVisibleChangeHandler = value => {
      if (trayMode) closeAllOptions();
      setIsButtonActive(value);
    };

    return !isSprinklrChatOpen ? (
      <div className={intercomClass}>
        {userLoggedIn ? (
          <Dropdown
            visible={isButtonActive}
            onVisibleChange={onVisibleChangeHandler}
            overlay={
              <div className={overlayContainerStyles}>
                {renderDropdownOverlay()}
              </div>
            }
            align={trayMode ? dropdownPosition : {}}
          >
            {renderIntercomIcon({ handler: onClickIntercomIcon })}
          </Dropdown>
        ) : (
          renderIntercomIcon({ handler: handleVisitorContactUs })
        )}
      </div>
    ) : null;
  };

  return !userLoggedIn ||
    isUserTypeStaff({ userType }) ||
    isUserTypeParent({ userType }) ||
    (isUserTypeStudent({ userType }) && showSprinklrChat)
    ? renderIntercomDropdown()
    : null;
};
const SupportDropdown = memo(_SupportDropdown);

const mapActionCreators = {
  goToRelativeRoute,
  openLinkInNewTab,
  toggleGlobalSearchBarModal,
  getWorkrampLoginUrl,
  toggleIsSprinklrChatOpen,
  setSprinklrUnreadMessageCount,
};

const mapStateToProps = (state, ownProps) => {
  const curriculumProgramId =
    getSelectedCurriculumId(state) || getUserCurriculumPrograms(state);
  const userInfo = getUserInfo();
  const userInfoPlanner = getUserInfo({ portalType: "PLANNER" });
  const userType = userInfo.user_type;
  const userId = _.get(userInfoPlanner, "id", "");
  const organizationId = _.get(userInfo, "org_id");
  const userEntityType = _.get(userInfoPlanner, "userEntityType", "");
  const routeCourseId = _.get(ownProps, "params.course_id");
  const { userCurriculumPrograms } = userInfo;
  const shouldShowGlobalSearchBar = !(
    isLibraryRoute(routeCourseId) || _.isEmpty(userCurriculumPrograms)
  );
  const curriculumType = _.get(state, "platform.currentCurriculumProgram.type");
  const isUBD = _.isEqual(curriculumType, CURRICULUM_TYPE_UBD);
  const isToddleLibrary = isToddleLibraryRoute();

  let contextFilters = [
    {
      contextType: "ORGANIZATION",
      contextId: organizationId,
    },
  ];
  _.forEach(userCurriculumPrograms, ({ id }) => {
    contextFilters = [
      ...contextFilters,
      {
        contextType: "CURRICULUM_PROGRAM",
        contextId: id,
      },
    ];
  });

  return {
    userInfo,
    curriculumProgramId,
    activeTab: _.get(state, "login.activeTab", "teacher"),
    userType,
    userId,
    userEntityType,
    showIntercom: _.get(state, "app_services.showIntercom", true),
    isIntercomV2Enabled: ACLStore.can("FeatureFlag:IntercomV2"),
    showSprinklrChat: getShowSprinklrChat({ userType }),
    isSprinklrChatOpen: _.get(state, "login.isSprinklrChatOpen", false),
    sprinklrUnreadMessageCount: _.get(
      state,
      "login.sprinklrUnreadMessageCount",
      0
    ),
    isGlobalSearchRevampEnabled: ACLStore.can(
      "FeatureFlag:EnableGlobalSearchJumpToRevamp"
    ),
    isGlobalSearchJumpToV2Enabled: ACLStore.can(
      "FeatureFlag:EnableGlobalSearchJumpToV2"
    ),
    shouldShowGlobalSearchBar,
    isUBD,
    userRnpRolesFilter: {
      contextFilters,
    },
    isToddleLibrary,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapActionCreators),
  getUserRnpRolesEnhancer
)(SupportDropdown);
